export { default } from './Team.component';
